module.exports = __webpack_public_path__ + "static/vegan-cola_label_old-f8128ab2f85337872b8880741b362496.jpg";